import { render, staticRenderFns } from "./SidebarActionPanel.vue?vue&type=template&id=2f23dd71&scoped=true"
import script from "./SidebarActionPanel.vue?vue&type=script&lang=js"
export * from "./SidebarActionPanel.vue?vue&type=script&lang=js"
import style0 from "./SidebarActionPanel.vue?vue&type=style&index=0&id=2f23dd71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23dd71",
  null
  
)

export default component.exports